(function () {
    "use strict";

    angular
        .module("app")
        .factory("SearchFactory", SearchFactory);

    //Hopefully this can start to be a replacement of the search "help" that is so hard to use.
    function SearchFactory($q, $rootScope, toaster, SearchHelpService) {
        return {
            //Two usages of factory here that could cause confusion:
            //Factories (physical entities, mostly in China) are being searched for.
            //The search object is created by a factory (code design pattern).
            factorySearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new FactorySearch(SearchHelpService));
            },
            patternNameSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new PatternNameSearch(SearchHelpService));
            },
            customerSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new CustomerSearch(SearchHelpService));
            },
            planningCategorySearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new PlanningCategorySearch(SearchHelpService));
            },
            activityTypeSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new ActivityTypeSearch(SearchHelpService));
            },
            strategicBusinessUnitSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new StrategicBusinessUnitSearch(SearchHelpService));
            },
            midsoleSearch: function (sapBrandId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new MidsoleSearch(SearchHelpService, sapBrandId));
            },
            outsoleSearch: function (sapBrandId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new OutsoleSearch(SearchHelpService, sapBrandId));
            },
            retailChannelSearch: function (sapBrandId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new RetailChannelSearch(SearchHelpService, sapBrandId));
            },
            basicMaterialSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new BasicMaterialSearch(SearchHelpService));
            },
            collectionSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new CollectionSearch(SearchHelpService));
            },
            businessSegmentSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new BusinessSegmentSearch(SearchHelpService));
            },
            genderSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new GenderSearch(SearchHelpService));
            },
            htsDutySearch: function (originCountry, destCountry, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new HTSDutySearch(SearchHelpService, originCountry, destCountry));
            },
            productHierarchySearch: function (sapBrandId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new ProductHierarchySearch(SearchHelpService, sapBrandId));
            },
            divisionSearch: function (sapBrandId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new DivisionSearch(SearchHelpService, sapBrandId));
            },
            basicColorSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new BasicColorSearch(SearchHelpService));
            },
            lastSearch: function (brandId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new LastSearch(SearchHelpService, brandId));
            },
            constructionSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new ConstructionSearch(SearchHelpService));
            },
            cuttingPatternSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new CuttingPatternSearch(SearchHelpService));
            },
            upperDescriptionSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new UpperDescriptionSearch(SearchHelpService));
            },
            membraneSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new MembraneSearch(SearchHelpService));
            },
            freightGroupSearch: function (sapBrandId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new FreightGroupSearch(SearchHelpService, sapBrandId));
            },
            materialGridSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new MaterialGridSearch(SearchHelpService));
            },
            qualitySearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new QualitySearch(SearchHelpService));
            },
            compoundSearch: function (sapBrandId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new CompoundSearch(SearchHelpService, sapBrandId));
            },
            toeComponentSearch: function (sapBrandId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new ToeComponentSearch(SearchHelpService, sapBrandId));
            },
            patternDescriptionSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new PatternDescriptionSearch(SearchHelpService));
            },
            nrfColorSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new NrfColorSearch(SearchHelpService));
            },
            consumerTerritorySearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new ConsumerTerritorySearch(SearchHelpService));
            },
            storyTypeSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new StoryTypeSearch(SearchHelpService));
            },
            developerSearch: function (brandId, roleId, onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new DeveloperSearch(SearchHelpService, brandId, roleId));
            },
            developmentCenterSearch: function (onSelect) {
                return create($q, $rootScope, toaster, SearchHelpService, onSelect, new DevelopmentCenterSearch(SearchHelpService));
            }
        };
    }

    function create($q, $rootScope, toaster, searchHelpService, onSelect, supr) {
        supr.searchResults = [];
        supr.favorites = [];
        supr.searchParameters = {};
        supr.onSelect = onSelect;
        supr.searching = false;
        supr.pageNumber = 1;
        supr.pageSize = 50;
        supr.showFavorites = true;
        supr.modalId = "#searchHelpModalNew";
        supr.lastSelected = null;
        supr.buttons = [];
        supr.showCancel = false;
        supr.cancelText = "Cancel";

        supr.mapList = function (list) {
            return $.map(list, function (item) {
                item.searchResult = item;
                item.Id = supr.getId(item);
                return item;
            });
        };

        supr.select = function (mappedItem) {
            supr.lastSelected = mappedItem;
            if (supr.onSelect(mappedItem.searchResult) !== false)
                supr.hideSearch();
        };

        supr.showSearch = function () {
            $rootScope.modalSearch = supr;
            $(supr.modalId).modal({ backdrop: "static", keyboard: false });
            $(supr.modalId).modal("show");
        };

        supr.hideSearch = function () {
            $(supr.modalId).modal("hide");
            $rootScope.modalSearch = null;
        };

        supr.setModal = function (modalId) {
            if (!modalId)
                return;

            if (!modalId.startsWith("#"))
                modalId = "#" + modalId;

            supr.modalId = modalId;
        };

        supr.clearParameters = function () {
            supr.searchParameters = {};
            if (supr.parameters) {
                for (var p in supr.parameters) {
                    supr.parameters[p].value = "";
                }
            }
        };

        supr.loadSearch = function (pageNumber, pageSize) {
            supr.pageNumber = pageNumber;
            supr.pageSize = pageSize;
            supr.search(false);
        };

        supr.findFavoriteItem = function (itemArray, id) {
            for (var idx = 0; idx < itemArray.length; idx++) {
                if (itemArray[idx].Id !== undefined && itemArray[idx].Id === id) {
                    return idx;
                }
            }
            return -1;
        };

        supr.handleFavorite = function (item) {
            if (item.isFavorite)
                return supr.removeFavorite(item.Id);
            else
                return supr.addFavorite(item, item.Id);
        };

        supr.removeFavorite = function (id) {
            var fav = searchHelpService.removePersonalFavorite(supr.key, id);

            var idx = supr.findFavoriteItem(supr.favorites, id);
            if (idx >= 0)
                supr.favorites.splice(idx, 1);

            idx = supr.findFavoriteItem(supr.searchResults, id);
            if (idx >= 0)
                supr.searchResults[idx].isFavorite = false;

            return fav;
        };

        supr.addFavorite = function (item, keyId) {
            var fav = searchHelpService.savePersonalFavorite(supr.key, keyId);
            item.isFavorite = !item.isFavorite;
            supr.favorites.push(item);
            return fav;
        };

        supr.favoritesAsync = function () {
            var deferred = $q.defer();

            if (!supr.favoritesService) {
                deferred.resolve();
                return deferred.promise;
            }

            supr.searching = true;

            supr.favoritesService().then(function (results) {
                supr.favorites = supr.mapList(results);

                angular.forEach(supr.favorites, function (item) {
                    item.isFavorite = true;
                });

                supr.searching = false;

                if (supr.favorites.length === 0) {
                    supr.toggleFavorites(false);
                }

                deferred.resolve(results);

            }, function (result) {
                toaster.pop({ type: "error", title: "Error!", body: result, timeout: 5000 });
                supr.hideSearch();
            });

            return deferred.promise;
        };

        supr.toggleFavorites = function (show) {
            if (show !== supr.showFavorites) {
                supr.showFavorites = show;
                supr.onShowFavoritesChanged();
            }
        };

        supr.onShowFavoritesChanged = function () {
            $rootScope.$broadcast("showFavorites", supr.showFavorites);
        };

        supr.onSearchHelpCompleted = function () {
            $rootScope.$broadcast("searchHelpCompleted", supr.showFavorites);
        };

        supr.searchAsync = function (searchFunc) {
            var deferred = $q.defer();
            supr.searching = true;

            supr.favoritesAsync().then(function () {
                searchFunc().then(function (search) {
                    supr.searchResults = supr.mapList(search.Results);

                    $rootScope.pagerData = {
                        CurrentPageNumber: search.CurrentPageNumber,
                        PageSize: search.PageSize,
                        TotalPageCount: search.TotalPageCount,
                        TotalRecords: search.TotalRecords
                    };

                    angular.forEach(supr.searchResults, function (item) {
                        var idx = supr.findFavoriteItem(supr.favorites, item.Id);
                        // need this check -- favorite may *not* be in the search helps that are in memory....
                        item.isFavorite = idx >= 0 ? true : false;
                    });

                    supr.searching = false;
                    deferred.resolve(search.Results);

                    supr.onSearchHelpCompleted();

                }, function (result) {
                    toaster.pop({ type: "error", title: "Error!", body: result, timeout: 5000 });
                    supr.hideSearch();
                });
            });


            return deferred.promise;
        };

        supr.startSearch = function (forValidation, paramValues, suppressPopup) {
            if (paramValues) {
                for (var i = 0; i < paramValues.length; i++) {
                    var value = paramValues[i];
                    if (forValidation) {
                        value = supr.getSearchValue(value, supr.parameters[i].validationSearchType);
                    }
                    supr.parameters[i].value = value;
                }
            }

            supr.toggleFavorites(!forValidation);

            if (forValidation) {
                supr.search().then(function (results) {
                    if (results.length === 1) {
                        supr.onSelect(results[0]);
                    } else {
                        if (results.length === 0) {
                            supr.onSelect(null);
                        }
                        if (suppressPopup !== true)
                            supr.showSearch();
                    }
                });
            } else {
                if (suppressPopup !== true)
                    supr.showSearch();
                supr.search();
            }
        };

        supr.containsValue = function (value) {
            if (!value)
                return "";

            if (!value.match(/^\*/)) {
                value = "*" + value;
            }

            if (!value.match(/\*$/)) {
                value = value + "*";
            }

            return value;
        };

        supr.startsWithValue = function (value) {
            if (!value)
                return "";

            if (!value.match(/^\*/)) {
                value = "*" + value;
            }

            return value;
        };

        supr.endsWithValue = function (value) {
            if (!value)
                return "";

            if (!value.match(/\*$/)) {
                value = value + "*";
            }

            return value;
        };

        supr.getSearchValue = function (value, searchType) {
            if (searchType === "equals")
                return value;

            if (searchType === "startsWith")
                return supr.startsWithValue(value);
            if (searchType === "endsWith")
                return supr.endsWithValue(value);

            return supr.containsValue(value);
        };

        supr.sortColumn = function () {
            return _.find(supr.columns, function (col) { return col.sort }).name;
        }

        supr.favColumnName = function () {
            return _.find(supr.columns, function (col) { return col.sort }).display;
        }

        supr.favColumnNameValue = function () {
            return _.find(supr.columns, function (col) { return col.sort }).name;
        }

        return supr;
    }

    function FactorySearch(searchHelpService) {
        var self = this;

        self.key = "FACTORY";
        self.title = "Factory";
        self.columns = [
            { name: "FactoryKey", header: "Factory Key", sort: true, favorite: true },
            { name: "FactoryName", header: "Factory Name", sort: false, favorite: false },
            { name: "Country", header: "Country", sort: false, favorite: false },
            { name: "FactoryGroupName", header: "Factory Group", sort: false, favorite: false }
        ];

        self.favoritesService = searchHelpService.getFactoryFavorites;

        self.getId = function (item) {
            return item.FactoryId || item.searchResult.FactoryId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { FactoryKey: self.parameters[0].value, FactoryName: self.parameters[1].value, FactoryGroupName: self.parameters[2].value };
                return searchHelpService.searchFactories(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "FACTORY_ID", header: "Factory Id", value: "", validationSearchType: "equals" },
            { name: "FACTORY_NAME", header: "Factory Name", value: "", validationSearchType: "equals" },
            { name: "FACTORY_GROUP_NAME", header: "Factory Group", value: "", validationSearchType: "equals" }
        ];
    }

    function PatternNameSearch(searchHelpService) {
        var self = this;

        self.key = "PATTERN_NAME";
        self.title = "Pattern Name";
        self.columns = [
            { name: "PatternNameKey", header: "Pattern Id", sort: true, favorite: true },
            { name: "PatternName", header: "Pattern Name", sort: false, favorite: false },
            { name: "Description", header: "Description", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getPatternNamesFavorites;

        self.getId = function (item) {
            return item.PatternId || item.searchResult.PatternId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { PatternNameKey: self.parameters[0].value, Name: self.parameters[1].value };
                return searchHelpService.searchPatternNames(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "PATTERN_ID", header: "Pattern Id", value: "", validationSearchType: "equals" },
            { name: "PATTERN_NAME", header: "Pattern Name", value: "", validationSearchType: "equals" }
        ];
    }

    function CustomerSearch(searchHelpService) {
        var self = this;

        self.key = "CUSTOMER";
        self.title = "Customer";
        self.columns = [
            { name: "CustomerKey", header: "Customer Id", sort: false, favorite: true },
            { name: "CustomerName", header: "Customer Name", sort: true, favorite: false },
            { name: "", header: "", sort: false, favorite: false }
        ];

        self.favoritesService = searchHelpService.getCustomerFavorites;

        self.getId = function (item) {
            return item.CustomerId || item.searchResult.CustomerId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { CustomerKey: self.parameters[0].value, CustomerName: self.parameters[1].value };
                return searchHelpService.searchCustomers(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "CUSTOMER_ID", header: "Customer Id", value: "", validationSearchType: "equals" },
            { name: "CUSTOMER_NAME", header: "Customer Name", value: "", validationSearchType: "equals" }
        ];
    }

    function PlanningCategorySearch(searchHelpService) {
        var self = this;

        self.key = "PLANNING_CATEGORY";
        self.title = "Planning Category";
        self.columns = [
            { name: "CharacteristicValue", header: "Planning Key", sort: true, favorite: true },
            { name: "CharacteristicDesc", header: "Planning Desc", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getPlanningCategoryFavorites;

        self.getId = function (item) {
            return item.CharacteristicId || item.searchResult.CharacteristicId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { CharacteristicKey: '0000002531', CharacteristicValue: self.parameters[0].value, CharacteristicDesc: self.parameters[1].value };
                return searchHelpService.searchPlanningCategories(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "CharValue", header: "Planning Key", value: "", validationSearchType: "equals" },
            { name: "CharDesc", header: "Planning Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function ActivityTypeSearch(searchHelpService) {
        var self = this;

        self.key = "ACTIVITY_TYPE";
        self.title = "Activity Type";
        self.columns = [
            { name: "CharacteristicValue", header: "Activity Key", sort: true, favorite: true },
            { name: "CharacteristicDesc", header: "Activity Desc", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getActivityTypeFavorites;

        self.getId = function (item) {
            return item.CharacteristicId || item.searchResult.CharacteristicId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { CharacteristicKey: '0000002525', CharacteristicValue: self.parameters[0].value, CharacteristicDesc: self.parameters[1].value };
                return searchHelpService.searchActivityTypes(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "CharValue", header: "Activity Key", value: "", validationSearchType: "equals" },
            { name: "CharDesc", header: "Activity Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function StrategicBusinessUnitSearch(searchHelpService) {
        var self = this;

        self.key = "STRATEGIC_BUSINESS_UNIT";
        self.title = "Strategic Business Unit";
        self.columns = [
            { name: "CharacteristicValue", header: "SBU Key", sort: true, favorite: true },
            { name: "CharacteristicDesc", header: "SBU Desc", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getStrategicBusinessUnitFavorites;

        self.getId = function (item) {
            return item.CharacteristicId || item.searchResult.CharacteristicId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { CharacteristicKey: '0000002530', CharacteristicValue: self.parameters[0].value, CharacteristicDesc: self.parameters[1].value };
                return searchHelpService.searchStrategicBusinessUnits(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "CharValue", header: "SBU Key", value: "", validationSearchType: "equals" },
            { name: "CharDesc", header: "SBU Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function MidsoleSearch(searchHelpService, sapBrandId) {
        var self = this;

        self.key = "MIDSOLE";
        self.title = "Midsole";
        self.columns = [
            { name: "MidsoleKey", header: "Midsole Key", sort: true, favorite: true },
            { name: "MidsoleName", header: "Midsole Desc", sort: false, favorite: false }];

        self.sapBrandId = sapBrandId;
        self.favoritesService = function () { return searchHelpService.getMidsoleFavorites(self.sapBrandId); };

        self.getId = function (item) {
            return item.MidsoleId || item.searchResult.MidsoleId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { MidsoleKey: self.parameters[0].value, MidsoleName: self.parameters[1].value, SAPBrandId: self.sapBrandId };
                return searchHelpService.searchMidsoles(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC", self.sapBrandId);
            });
        };

        self.parameters = [
            { name: "Midsole_Key", header: "Midsole Key", value: "", validationSearchType: "equals" },
            { name: "Midsole_Name", header: "Midsole Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function OutsoleSearch(searchHelpService, sapBrandId) {
        var self = this;

        self.key = "Outsole";
        self.title = "Outsole";
        self.columns = [
            { name: "OutsoleKey", header: "Outsole Key", sort: true, favorite: true },
            { name: "OutsoleName", header: "Outsole Desc", sort: false, favorite: false }];

        self.sapBrandId = sapBrandId;
        self.favoritesService = function () { return searchHelpService.getOutsoleFavorites(self.sapBrandId); };

        self.getId = function (item) {
            return item.OutsoleId || item.searchResult.OutsoleId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { OutsoleKey: self.parameters[0].value, OutsoleName: self.parameters[1].value, SAPBrandId: self.sapBrandId };
                return searchHelpService.searchOutsoles(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC", self.sapBrandId);
            });
        };

        self.parameters = [
            { name: "Outsole_Key", header: "Outsole Key", value: "", validationSearchType: "equals" },
            { name: "Outsole_Name", header: "Outsole Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function RetailChannelSearch(searchHelpService, sapBrandId) {
        var self = this;

        self.key = "RETAIL_CHANNEL";
        self.title = "Retail Channel";
        self.columns = [
            { name: "RetailChannelKey", header: "Retail Channel Id", sort: false, favorite: true },
            { name: "RetailChannelName", header: "Retail Channel Description", sort: true, favorite: false }];

        self.favoritesService = function () { return searchHelpService.getRetailChannelFavorites(self.sapBrandId); };
        self.sapBrandId = sapBrandId;

        self.getId = function (item) {
            return item.RetailChannelId || item.searchResult.RetailChannelId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { RetailChannelKey: self.parameters[0].value, RetailChannelName: self.parameters[1].value, SAPBrandId: self.sapBrandId };
                return searchHelpService.searchRetailChannels(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC", self.sapBrandId);
            });
        };

        self.parameters = [
            { name: "RETAIL_CHANNEL_ID", header: "Retail Channel Id", value: "", validationSearchType: "equals" },
            { name: "CHANNEL", header: "Retail Channel Description", value: "", validationSearchType: "equals" }
        ];
    }

    function BasicMaterialSearch(searchHelpService) {
        var self = this;

        self.key = "BASIC_MATERIAL";
        self.title = "Basic Material";
        self.columns = [
            { name: "BasicMaterialName", header: "Basic Material", sort: true, favorite: true }];

        self.favoritesService = searchHelpService.getBasicMaterialFavorites;

        self.getId = function (item) {
            return item.BasicMaterialId || item.searchResult.BasicMaterialId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { BasicMaterialName: self.parameters[0].value };
                return searchHelpService.searchBasicMaterials(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "BASIC_MATERIAL", header: "Basic Material", value: "", validationSearchType: "equals" }
        ];
    }

    function CollectionSearch(searchHelpService) {
        var self = this;

        self.key = "COLLECTION";
        self.title = "Collection";
        self.columns = [
            { name: "CollectionKey", header: "Collection Key", sort: true, favorite: true },
            { name: "CollectionName", header: "Collection Desc", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getCollectionFavorites;

        self.getId = function (item) {
            return item.CollectionId || item.searchResult.CollectionId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }

            return self.searchAsync(function () {
                self.searchParameters = { CollectionKey: self.parameters[0].value, CollectionName: self.parameters[1].value };
                return searchHelpService.searchCollections(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };


        self.parameters = [
            { name: "CollectionKey", header: "Collection Key", value: "", validationSearchType: "equals" },
            { name: "CollectionName", header: "Collection Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function BusinessSegmentSearch(searchHelpService) {
        var self = this;

        self.key = "BUSINESS_SEGMENT";
        self.title = "Business Segment";
        self.columns = [
            { name: "BusinessSegmentName", header: "Business Segment", sort: true, favorite: true }];

        self.favoritesService = searchHelpService.getBusinessSegmentFavorites;

        self.getId = function (item) {
            return item.BusinessSegmentId || item.searchResult.BusinessSegmentId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }

            return self.searchAsync(function () {
                self.searchParameters = { BusinessSegmentName: self.parameters[0].value };
                return searchHelpService.searchBusinessSegments(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "BUS_SEG", header: "Business Segment", value: "", validationSearchType: "equals" }
        ];
    }

    function GenderSearch(searchHelpService) {
        var self = this;

        self.key = "GENDER";
        self.title = "Gender";
        self.columns = [
            { name: "GenderKey", header: "Gender Key", sort: true, favorite: true },
            { name: "GenderName", header: "Gender Name", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getGenderFavorites;

        self.getId = function (item) {
            return item.GenderId || item.searchResult.GenderId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { GenderKey: self.parameters[0].value, GenderName: self.parameters[1].value };
                return searchHelpService.searchGenders(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "GENDER_ID", header: "Gender Id", value: "", validationSearchType: "equals" },
            { name: "GENDER_DESC", header: "Gender Description", value: "", validationSearchType: "equals" }
        ];
    }

    function HTSDutySearch(searchHelpService, originCountry, destCountry) {
        var self = this;

        self.key = "HTS_DUTY";
        self.title = "HTS Duty";

        self.columns = [
            { name: "HTSKey", header: "HTS Code Key", sort: true, favorite: true },
            { name: "HTSStawn", header: "HTS Stawn", sort: false, favorite: false },
            { name: "CountryOrigin", header: "Country Origin", sort: false, favorite: false },
            { name: "CountryDestination", header: "Country Destination", sort: false, favorite: false },
            { name: "Duty", header: "Assign Duty", sort: false, favorite: false }];

        self.destCountry = destCountry;
        self.originCountry = originCountry;
        self.favoritesService = function () { return searchHelpService.getHTSDutyFavorites(self.originCountry, self.destCountry); };

        self.getId = function (item) {
            return item.HTSDutyId || item.searchResult.HTSDutyId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { HTSStawn: self.parameters[0].value, CountryOrigin: self.originCountry, CountryDestination: self.destCountry };

                return searchHelpService.searchHTSDutys(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "HTSStawn", header: "HTS Code", value: "", validationSearchType: "equals" }
        ];
    }

    function ProductHierarchySearch(searchHelpService, sapBrandId) {
        var self = this;

        self.key = "PROD_HIER";
        self.title = "Product Hierarchy";
        self.columns = [
            { name: "ProductHierarchyKey", header: "Prod Hier Id", sort: true, favorite: true },
            { name: "ProductHierarchyName", header: "Description", sort: false, favorite: false }];

        self.favoritesService = function () { return searchHelpService.getProductHierarchyFavorites(self.sapBrandId) };
        self.sapBrandId = sapBrandId;

        self.getId = function (item) {
            return item.ProductHierarchyId || item.searchResult.ProductHierarchyId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { ProductHierarchyName: self.parameters[1].value, ProductHierarchyKey: self.parameters[0].value, SAPBrandId: self.sapBrandId };
                return searchHelpService.searchProductHierarchys(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "ProductHierarchy_ID", header: "Prod Hier Id", value: "", validationSearchType: "equals" },
            { name: "ProductHierarchy_DESC", header: "Prod Hier Level 1 Description", value: "", validationSearchType: "equals" }
        ];
    }

    function DivisionSearch(searchHelpService, sapBrandId) {
        var self = this;

        self.key = "DIVISION";
        self.title = "Division";
        self.columns = [
            { name: "DivisionKey", header: "Division", sort: true, favorite: true },
            { name: "DivisionName", header: "Division Name", sort: false, favorite: false }];

        self.favoritesService = function () { return searchHelpService.getDivisionFavorites(self.sapBrandId); };
        self.sapBrandId = sapBrandId;

        self.getId = function (item) {
            return item.DivisionId || item.searchResult.DivisionId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { DivisionName: self.parameters[0].value, DivisionKey: self.parameters[1].value, SAPBrandId: self.sapBrandId };
                return searchHelpService.searchDivisions(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "Division_DESC", header: "Division Name", value: "", validationSearchType: "equals" },
            { name: "Division_ID", header: "Division", value: "", validationSearchType: "equals" }
        ];
    }

    function BasicColorSearch(searchHelpService) {
        var self = this;

        self.key = "BASIC_COLOR";
        self.title = "Basic Color";
        self.columns = [
            { name: "BasicColorKey", header: "Color Id", sort: true, favorite: true },
            { name: "BasicColorName", header: "Color Description", sort: false, favorite: false },
            { name: "NRFId", header: "NRF Id", sort: false, favorite: false },
            { name: "NRFName", header: "NRF Desc", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getBasicColorFavorites;

        self.getId = function (item) {
            return item.BasicColorId || item.searchResult.BasicColorId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { BasicColorKey: self.parameters[1].value, BasicColorName: self.parameters[0].value };
                return searchHelpService.searchBasicColors(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "GENDER_ID", header: "Color Description", value: "", validationSearchType: "equals" },
            { name: "GENDER_DESC", header: "Color Id", value: "", validationSearchType: "equals" }
        ];
    }

    function LastSearch(searchHelpService, brandId) {
        var self = this;

        self.key = "Last";
        self.title = "Last";
        self.columns = [
            { name: "LastId", header: "Last Id", sort: true, favorite: true },
            { name: "LastName", header: "Name", sort: false, favorite: false },
            { name: "LastDesc", header: "Desc", sort: false, favorite: false }];

        self.favoritesService = function () { return searchHelpService.getLastFavorites(self.brandId); };
        self.brandId = brandId;

        self.getId = function (item) {
            return item.LastId || item.searchResult.LastId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { LastDesc: self.parameters[1].value, LastName: self.parameters[0].value, BrandId: self.brandId };
                var searchresults = searchHelpService.searchLasts(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
                return searchresults;
            });
        };

        self.parameters = [
            { name: "Last_ID", header: "Last Name", value: "", validationSearchType: "equals" },
            { name: "Last_DESC", header: "Last Description", value: "", validationSearchType: "equals" }
        ];
    }

    function ConstructionSearch(searchHelpService) {
        var self = this;

        self.key = "CONSTRUCTION";
        self.title = "Construction";
        self.columns = [
            { name: "ConstructionKey", header: "Construction Id", sort: true, favorite: true },
            { name: "ConstructionDesc", header: "Construction Name", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getConstructionFavorites;

        self.getId = function (item) {
            return item.ConstructionId || item.searchResult.ConstructionId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { ConstructionKey: self.parameters[0].value, ConstructionDesc: self.parameters[1].value };
                return searchHelpService.searchConstructions(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "GENDER_ID", header: "Construction Key", value: "", validationSearchType: "equals" },
            { name: "GENDER_DESC", header: "Construction Description", value: "", validationSearchType: "equals" }
        ];
    }

    function CuttingPatternSearch(searchHelpService) {
        var self = this;

        self.key = "CUTTING_PATTERN";
        self.title = "Cutting Pattern";
        self.columns = [
            { name: "CuttingPatternName", header: "Cutting Pattern", sort: true, favorite: true }];

        self.favoritesService = searchHelpService.getCuttingPatternFavorites;

        self.getId = function (item) {
            return item.CuttingPatternId || item.searchResult.CuttingPatternId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { CuttingPatternName: self.parameters[0].value };
                return searchHelpService.searchCuttingPatterns(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "CuttingPattern", header: "Cutting Pattern", value: "", validationSearchType: "equals" }
        ];
    }

    function UpperDescriptionSearch(searchHelpService) {
        var self = this;

        self.key = "PICTOGRAM";
        self.title = "Upper Description / Pictogram";
        self.columns = [
            { name: "PictogramKey", header: "Pictogram Label Id", sort: true, favorite: true },
            { name: "UpperDesc", header: "Upper Description", sort: false, favorite: false },
            { name: "LiningDesc", header: "Lining Description", sort: false, favorite: false },
            { name: "OutsoleDesc", header: "Outsole Description", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getUpperDescriptionFavorites;

        self.getId = function (item) {
            return item.PictogramId || item.searchResult.PictogramId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { UpperDesc: self.parameters[0].value, LiningDesc: self.parameters[1].value, OutsoleDesc: self.parameters[2].value, PictogramKey: self.parameters[3].value };
                return searchHelpService.searchUpperDescriptions(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "UpperDescription", header: "Upper Description", value: "", validationSearchType: "equals" },
            { name: "LiningDescription", header: "Lining Description", value: "", validationSearchType: "equals" },
            { name: "OutsoleDescription", header: "Outsole Description", value: "", validationSearchType: "equals" },
            { name: "PictogramId", header: "Pictogram Label ID", value: "", validationSearchType: "equals" }
        ];
    }

    function MembraneSearch(searchHelpService) {
        var self = this;

        self.key = "MEMBRANE";
        self.title = "Membrane";
        self.columns = [
            { name: "MembraneId", header: "Membrane Id", sort: false, favorite: true },
            { name: "MembraneDesc", header: "Membrane Description", sort: true, favorite: false }];

        self.favoritesService = searchHelpService.getMembraneFavorites;

        self.getId = function (item) {
            return item.MembraneId || item.searchResult.MembraneId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { MembraneId: self.parameters[0].value, MembraneDesc: self.parameters[1].value };
                return searchHelpService.searchMembranes(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "Membrane", header: "Membrane Id", value: "", validationSearchType: "equals" },
            { name: "Membrane", header: "Membrane Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function MaterialGridSearch(searchHelpService) {
        var self = this;

        self.key = "MASTER_GRID";
        self.title = "Material Grid";
        self.columns = [
            { name: "MaterialGridId", header: "Material Grid Key", sort: false, favorite: true },
            { name: "MaterialGridName", header: "Material Description", sort: true, favorite: false }];

        self.favoritesService = searchHelpService.getMaterialGridFavorites;

        self.getId = function (item) {
            return item.MaterialGridId || item.searchResult.MaterialGridId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { MaterialGridName: self.parameters[0].value, MaterialGridDesc: self.parameters[1].value };
                return searchHelpService.searchMaterialGrids(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "MaterialGridName", header: "Material Grid Id", value: "", validationSearchType: "equals" },
            { name: "MaterialGridDesc", header: "Material Grid Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function FreightGroupSearch(searchHelpService, sapBrandId) {
        var self = this;

        self.key = "FREIGHT_GRP_BY_BRANDID";
        self.title = "Freight Group";

        self.columns = [
            { name: "FreightGroupKey", header: "FRGP Id", sort: true, favorite: true },
            { name: "FreightGroupName", header: "Description", sort: false, favorite: false }];

        self.favoritesService = function () { return searchHelpService.getFreightGroupFavorites(self.sapBrandId); };
        self.sapBrandId = sapBrandId;

        self.getId = function (item) {
            return item.FreightGroupId || item.searchResult.FreightGroupId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { FreightGroupName: self.parameters[0].value, FreightGroupKey: self.parameters[1].value, SAPBrandId: self.sapBrandId };
                return searchHelpService.searchFreightGroups(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "FreightGroup_DESC", header: "Freight Group Description", value: "", validationSearchType: "equals" },
            { name: "FreightGroup_ID", header: "Freight Group Id", value: "", validationSearchType: "equals" }
        ];
    }

    function QualitySearch(searchHelpService) {
        var self = this;

        self.key = "QUALITY_CATEGORY";
        self.title = "Quality Category";
        self.columns = [
            { name: "QualityCategoryKey", header: "CATEGORY", sort: true, favorite: true },
            { name: "QualityCategoryName", header: "DESC", sort: false, favorite: false },
            { name: "Enam", header: "ERNAM", sort: false, favorite: false },
            { name: "Qcid", header: "QCID", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getQualityFavorites;

        self.getId = function (item) {
            return item.QualityCategoryId || item.searchResult.QualityCategoryId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { QualityCategoryKey: self.parameters[1].value, QualityCategoryName: self.parameters[0].value, Qcid: self.parameters[2].value };
                return searchHelpService.searchQualitys(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "QualityDesc", header: "Qual Description", value: "", validationSearchType: "equals" },
            { name: "QualityCategory", header: "Qual Category", value: "", validationSearchType: "equals" },
            { name: "QCID", header: "QCID", value: "", validationSearchType: "equals" }
        ];
    }

    function CompoundSearch(searchHelpService, sapBrandId) {
        var self = this;

        self.key = "COMPOUND";
        self.title = "Compound";
        self.columns = [
            { name: "CompoundId", header: "Compound Id", sort: true, favorite: true },
            { name: "CompoundKey", header: "Compound Key", sort: false, favorite: false },
            { name: "CompoundDesc", header: "Compound Desc", sort: false, favorite: false }];

        self.favoritesService = function () { return searchHelpService.getCompoundFavorites(self.sapBrandId); };
        self.sapBrandId = sapBrandId;

        self.getId = function (item) {
            return item.CompoundId || item.searchResult.CompoundId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { CompoundDesc: self.parameters[0].value, SAPBrandId: self.sapBrandId };
                return searchHelpService.searchCompounds(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "Compound_DESC", header: "Compound Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function ToeComponentSearch(searchHelpService, sapBrandId) {
        var self = this;

        self.key = "TOE";
        self.title = "Toe Component";
        self.columns = [
            { name: "ToeComponentId", header: "Toe Component Id", sort: true, favorite: true },
            { name: "ToeComponentKey", header: "Toe Component Key", sort: false, favorite: false },
            { name: "ToeComponentDesc", header: "Toe Component Desc", sort: false, favorite: false }];

        self.favoritesService = function () { return searchHelpService.getToeComponentFavorites(self.sapBrandId); };
        self.sapBrandId = sapBrandId;

        self.getId = function (item) {
            return item.ToeComponentId || item.searchResult.ToeComponentId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { ToeComponentDesc: self.parameters[0].value, ToeComponentKey: self.parameters[1].value, SAPBrandId: self.sapBrandId };
                var items = searchHelpService.searchToeComponents(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
                return items;
            });
        };

        self.parameters = [
            { name: "ToeComponent_Desc", header: "Component Desc", value: "", validationSearchType: "equals" },
            { name: "ToeComponent_Key", header: "Component Key", value: "", validationSearchType: "equals" }
        ];
    }

    function PatternDescriptionSearch(searchHelpService) {
        var self = this;

        self.key = "PATTERN_DESC";
        self.title = "Pattern Description";
        self.columns = [
            { name: "Description", header: "Pattern Description", sort: true, favorite: true }];

        self.favoritesService = function () { return searchHelpService.getPatternDescriptionFavorites(); };

        self.getId = function (item) {
            return item.PatternDescriptionId || item.searchResult.PatternDescriptionId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { Description: self.parameters[0].value };
                return searchHelpService.searchPatternDescriptions(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "PatternDescription_Desc", header: "Pattern Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function NrfColorSearch(searchHelpService) {
        var self = this;

        self.key = "NRF_COLOR";
        self.title = "NRF Color";
        self.columns = [
            { name: "NrfColorKey", header: "NRF Color Key", sort: false, favorite: false },
            { name: "NrfColorName", header: "NRF Color Name", sort: true, favorite: true }];

        self.favoritesService = function () { return searchHelpService.getNrfColorFavorites(); };

        self.getId = function (item) {
            return item.NrfColorId || item.searchResult.NrfColorId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { NrfColorKey: self.parameters[0].value, NrfColorName: self.parameters[1].value };
                return searchHelpService.searchNrfColors(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "NrfColorKey", header: "NRF Color Key", value: "", validationSearchType: "equals" },
            { name: "NrfColorName", header: "NRF Color Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function StoryTypeSearch(searchHelpService) {
        var self = this;

        self.key = "STORY_TYPE";
        self.title = "Story Type";
        self.columns = [
            { name: "CharacteristicValue", header: "Story Type Key", sort: true, favorite: true },
            { name: "CharacteristicDesc", header: "Story Type Desc", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getStoryTypeFavorites;

        self.getId = function (item) {
            return item.CharacteristicId || item.searchResult.CharacteristicId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { CharacteristicKey: '0000002587', CharacteristicValue: self.parameters[0].value, CharacteristicDesc: self.parameters[1].value };
                return searchHelpService.searchStoryTypes(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "StoryTypeKey", header: "Story Type Key", value: "", validationSearchType: "equals" },
            { name: "StoryTypeDesc", header: "Story Type Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function ConsumerTerritorySearch(searchHelpService) {
        var self = this;

        self.key = "CONSUMER_TERRITORY";
        self.title = "Consumer Territory";
        self.columns = [
            { name: "CharacteristicValue", header: "Consumer Territory Key", sort: true, favorite: true },
            { name: "CharacteristicDesc", header: "Consumer Territory Desc", sort: false, favorite: false }];

        self.favoritesService = searchHelpService.getConsumerTerritoryFavorites;

        self.getId = function (item) {
            return item.CharacteristicId || item.searchResult.CharacteristicId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { CharacteristicKey: '0000002586', CharacteristicValue: self.parameters[0].value, CharacteristicDesc: self.parameters[1].value };
                return searchHelpService.searchConsumerTerritorys(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "ConsumerTerritoryKey", header: "Consumer Territory Key", value: "", validationSearchType: "equals" },
            { name: "ConsumerTerritoryDesc", header: "Consumer Territory Desc", value: "", validationSearchType: "equals" }
        ];
    }

    function DeveloperSearch(searchHelpService, brandId, developerRoleId) {
        var self = this;

        self.key = "DEVELOPER";
        self.title = "Developer";

        self.columns = [
            { name: "FirstName", header: "First Name", sort: false, favorite: false },
            { name: "LastName", header: "Last Name", sort: false, favorite: false },
            { name: "UserName", header: "Username", sort: true, favorite: true }];

        self.favoritesService = null;

        self.getId = function (item) {
            return item.DeveloperId || item.searchResult.DeveloperId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { BrandId: brandId, RoleId: developerRoleId, FirstName: self.parameters[0].value, LastName: self.parameters[1].value };
                return searchHelpService.searchDevelopers(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "FirstName", header: "First Name", value: "", validationSearchType: "equals" },
            { name: "LastName", header: "Last Name", value: "", validationSearchType: "equals" }
        ];
    }

    function DevelopmentCenterSearch(searchHelpService) {
        var self = this;

        self.key = "DEVELOPMENT_CENTER";
        self.title = "Development Center";

        self.columns = [
            { name: "DevelopmentCenterKey", header: "Key", sort: false, favorite: false },
            { name: "DevelopmentCenterName", header: "Name", sort: true, favorite: false }
        ];

        self.favoritesService = null;

        self.getId = function (item) {
            return item.DeveloperId || item.searchResult.DeveloperId;
        }

        self.search = function (resetPage) {
            if (resetPage) {
                self.pageNumber = 1;
                self.toggleFavorites(false);
            }
            return self.searchAsync(function () {
                self.searchParameters = { DevelopmentCenterKey: self.parameters[0].value, DevelopmentCenterName: self.parameters[1].value };
                return searchHelpService.searchDevelopmentCenters(self.searchParameters, self.pageNumber, self.pageSize, self.sortColumn(), "ASC");
            });
        };

        self.parameters = [
            { name: "DevelopmentCenterKey", header: "Key", value: "", validationSearchType: "equals" },
            { name: "DevelopmentCenterName", header: "Name", value: "", validationSearchType: "equals" }
        ];
    }

})();
